// apiClient.ts
import axios from "axios";

// Resolve API base from env; default to local dev API if unset
const BASE_URL = (
  typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL
)
  ? String(process.env.REACT_APP_API_URL).replace(/\/+$/, '')
  : "https://manasik.dwsoftwares.com/api";
  // : "http://localhost:8000/api";

// Optional timeout from env
const TIMEOUT = (
  typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_TIMEOUT
)
  ? Number(process.env.REACT_APP_API_TIMEOUT)
  : 30000;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  withCredentials: false,
});

// ⬇️ هنا السحر
api.interceptors.request.use((config) => {
  const token  = localStorage.getItem("auth_token");
  const tenant = localStorage.getItem("tenant") || "default-tenant-1";
  const branch = localStorage.getItem("branch") ?? "1"; // فرع افتراضي إذا لم يُحدد
  
  if (!config.headers) config.headers = new axios.AxiosHeaders();
  config.headers["X-Tenant"] = tenant;
  config.headers["X-Branch"] = branch; // أرسل دائماً الفرع مع قيمة افتراضية
  config.headers["Accept"] = "application/json";
  const vault = localStorage.getItem("vault");
  if (vault) config.headers["X-Vault"] = vault;
  
  // Authorization
  if (token) config.headers["Authorization"] = `Bearer ${token}`;

  return config;
});



api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("auth_token");
      // window.location.href = "/login";
  }
  return Promise.reject(err);
  }
);

// Removed dev-only baseURL console logging

export default api;
